import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// FontAwesome - Regular icons
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons/faPenToSquare';
import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons/faEyeSlash';
import { faMinus } from '@fortawesome/pro-regular-svg-icons/faMinus';
import { faShoppingBasket } from '@fortawesome/pro-regular-svg-icons/faShoppingBasket';
import { faAbacus } from '@fortawesome/pro-regular-svg-icons/faAbacus';
import { faRotate } from '@fortawesome/pro-regular-svg-icons/faRotate';
import { faBackwardStep } from '@fortawesome/pro-regular-svg-icons/faBackwardStep';
import { faForwardStep } from '@fortawesome/pro-regular-svg-icons/faForwardStep';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons/faAngleDown';
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight';
import { faArrowCircleLeft } from '@fortawesome/pro-regular-svg-icons/faArrowCircleLeft';
import { faArrowFromLeft } from '@fortawesome/pro-regular-svg-icons/faArrowFromLeft';
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons/faArrowUp';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import { faAt } from '@fortawesome/pro-regular-svg-icons/faAt';
import { faBan } from '@fortawesome/pro-regular-svg-icons/faBan';
import { faBars } from '@fortawesome/pro-regular-svg-icons/faBars';
import { faBell } from '@fortawesome/pro-regular-svg-icons/faBell';
import { faBellSlash } from '@fortawesome/pro-regular-svg-icons/faBellSlash';
import { faBoxFull } from '@fortawesome/pro-regular-svg-icons/faBoxFull';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import { faChartBar } from '@fortawesome/pro-regular-svg-icons/faChartBar';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faChevronCircleLeft } from '@fortawesome/pro-regular-svg-icons/faChevronCircleLeft';
import { faChevronCircleRight } from '@fortawesome/pro-regular-svg-icons/faChevronCircleRight';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faSquare } from '@fortawesome/pro-regular-svg-icons/faSquare';
import { faStar } from '@fortawesome/pro-regular-svg-icons/faStar';
import { faStarHalfStroke } from '@fortawesome/pro-regular-svg-icons/faStarHalfStroke';
import { faSignal } from '@fortawesome/pro-regular-svg-icons/faSignal';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { faSquareCheck } from '@fortawesome/pro-regular-svg-icons/faSquareCheck';
import { faCircle } from '@fortawesome/pro-regular-svg-icons/faCircle';
import { faCircleDot } from '@fortawesome/pro-regular-svg-icons/faCircleDot';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons/faQuestionCircle';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { faImageSlash } from '@fortawesome/pro-regular-svg-icons/faImageSlash';
import { faCreditCard } from '@fortawesome/pro-regular-svg-icons/faCreditCard';
import { faGlobe } from '@fortawesome/pro-regular-svg-icons/faGlobe';
import { faMobileScreen } from '@fortawesome/pro-regular-svg-icons/faMobileScreen';



import { faSliders } from '@fortawesome/pro-regular-svg-icons/faSliders';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';

// FontAwesome - Solid icons
import { faArrowLeft as faArrowLeftSolid } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { faCheckCircle as faCheckCircleSolid } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faChevronCircleLeft as faChevronCircleLeftSolid } from '@fortawesome/pro-solid-svg-icons/faChevronCircleLeft';
import { faChevronCircleRight as faChevronCircleRightSolid } from '@fortawesome/pro-solid-svg-icons/faChevronCircleRight';
import { faChevronDown as faChevronDownSolid } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronLeft as faChevronLeftSolid } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight as faChevronRightSolid } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faCircleInfo as faCircleInfoSolid } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { faInfo as faInfoSolid } from '@fortawesome/pro-solid-svg-icons/faInfo';
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faCaretDown as faCaretDownSolid } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faEdit as faEditSolid } from '@fortawesome/pro-solid-svg-icons/faEdit';
import { faPhone as faPhoneSolid } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faMagnifyingGlass as faMagnifyingGlassSolid } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass';
import { faUser as faUserSolid } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faBars as faBarsSolid } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faSquare as faSquareSolid } from '@fortawesome/pro-solid-svg-icons/faSquare';
import { faSquareCheck as faSquareCheckSolid } from '@fortawesome/pro-solid-svg-icons/faSquareCheck';
import { faCheck as faCheckSolid } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faTriangleExclamation as faTriangleExclamationSolid } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { faPlay as faPlaySolid } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { faSignalStrong } from '@fortawesome/pro-solid-svg-icons/faSignalStrong';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle';

// FontAwesome - Light icons
import { faChevronLeft as faChevronLeftLight } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import { faTrashCan as faTrashCanLight } from '@fortawesome/pro-light-svg-icons/faTrashCan';
import { faPrint as faPrintLight } from '@fortawesome/pro-light-svg-icons/faPrint';
import { faChevronUp as faChevronUpLight } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faChevronDown as faChevronDownLight } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faArrowsUpDown as faArrowsUpDownLight } from '@fortawesome/pro-light-svg-icons/faArrowsUpDown';
import { faAngleDown as faAngleDownLight } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { faMobileScreen as faMobileScreenLight } from '@fortawesome/pro-light-svg-icons/faMobileScreen';
import { faBatteryThreeQuarters as faBatteryThreeQuartersLight } from '@fortawesome/pro-light-svg-icons/faBatteryThreeQuarters';
import { faSimCard } from '@fortawesome/pro-light-svg-icons/faSimCard';
import { faSimCards } from '@fortawesome/pro-light-svg-icons/faSimCards';
import { faMemory } from '@fortawesome/pro-light-svg-icons/faMemory';
import { faRuler } from '@fortawesome/pro-light-svg-icons/faRuler';
import { faCamera } from '@fortawesome/pro-light-svg-icons/faCamera';
import { faWeightScale } from '@fortawesome/pro-light-svg-icons/faWeightScale';
import { faSignal as faSignalLight } from '@fortawesome/pro-light-svg-icons/faSignal';
import { faPhone as faPhoneLight } from '@fortawesome/pro-light-svg-icons/faPhone';
import { faMagnifyingGlass as faMagnifyingGlassLight } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { faUser as faUserLight } from '@fortawesome/pro-light-svg-icons/faUser';
import { faBars as faBarsLight } from '@fortawesome/pro-light-svg-icons/faBars';
import { faTruckFast } from '@fortawesome/pro-light-svg-icons/faTruckFast';
import { faBox } from '@fortawesome/pro-light-svg-icons/faBox';

// FontAwesome - Thin icons
import { faRuler as faRulerThin } from '@fortawesome/pro-thin-svg-icons/faRuler';
import { faCamera as faCameraThin } from '@fortawesome/pro-thin-svg-icons/faCamera';
import { faMobileScreen as faMobileScreenThin } from '@fortawesome/pro-thin-svg-icons/faMobileScreen';


// FontAwesome - Brand icons
import { faYoutube as faYoutubeBrand } from '@fortawesome/free-brands-svg-icons/faYoutube'
import { faFacebookF as faFacebookFBrand } from '@fortawesome/free-brands-svg-icons/faFacebookF'
import { faInstagram as faInstagramBrand } from '@fortawesome/free-brands-svg-icons/faInstagram'

library.add(
  faMobileScreen,
  faGlobe,
  faCreditCard,
  faTrashCanLight,
  faSignalStrong,
  faBox,
  faTruckFast,
  faPlaySolid,
  faMobileScreenThin,
  faCameraThin,
  faRulerThin,
  faTriangleExclamationSolid,
  faImageSlash,
  faCheckSolid,
  faMagnifyingGlassLight,
  faPhoneLight,
  faUserLight,
  faBarsLight,
  faMagnifyingGlassSolid,
  faPhoneSolid,
  faUserSolid,
  faBarsSolid,
  faSquareCheckSolid,
  faSquareSolid,
  faYoutubeBrand,
  faFacebookFBrand,
  faInstagramBrand,
  faSearch,
  faQuestionCircle,
  faCircle,
  faCircleDot,
  faSquareCheck,
  faPenToSquare,
  faEye,
  faEyeSlash,
  faSliders,
  faMinus,
  faChevronLeftLight,
  faPrintLight,
  faShoppingBasket,
  faStar,
  faCaretDownSolid,
  faSliders,
  faStarHalfStroke,
  faStarSolid,
  faAbacus,
  faArrowsUpDownLight,
  faSignalLight,
  faRotate,
  faBackwardStep,
  faForwardStep,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowCircleLeft,
  faArrowFromLeft,
  faArrowUp,
  faArrowLeft,
  faArrowLeftSolid,
  faArrowRight,
  faAt,
  faBan,
  faBars,
  faBell,
  faBellSlash,
  faBoxFull,
  faCalendarAlt,
  faChartBar,
  faCheck,
  faCheckCircle,
  faCheckCircleSolid,
  faTimesCircle,
  faEditSolid,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronCircleLeftSolid,
  faChevronCircleRightSolid,
  faCircleInfoSolid,
  faInfoSolid,
  faAngleDownLight,
  faChevronDown,
  faChevronDownSolid,
  faChevronLeftSolid,
  faChevronRight,
  faChevronLeft,
  faChevronRightSolid,
  faChevronUpLight,
  faChevronDownLight,
  faXmark,
  faSquare,
  faSliders,
  faPlus,
  faMinus,
  faAngleRight,
  faAngleLeft,
  faWeightScale,
  faSimCards,
  faSignal,
  faCamera,
  faRuler,
  faMemory,
  faSimCard,
  faMobileScreenLight,
  faBatteryThreeQuartersLight,
  faCheck
);

// This is important, we are going to let Nuxt.js worry about the CSS
config.autoAddCss = false

// Register the component globally
Vue.component('FontAwesomeIcon', FontAwesomeIcon)
